import { render, staticRenderFns } from "./HeroSectionMobile.vue?vue&type=template&id=2f374031&scoped=true&"
import script from "./HeroSectionMobile.vue?vue&type=script&lang=ts&setup=true&"
export * from "./HeroSectionMobile.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./HeroSectionMobile.vue?vue&type=style&index=0&id=2f374031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f374031",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f374031')) {
      api.createRecord('2f374031', component.options)
    } else {
      api.reload('2f374031', component.options)
    }
    module.hot.accept("./HeroSectionMobile.vue?vue&type=template&id=2f374031&scoped=true&", function () {
      api.rerender('2f374031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/HeroSectionMobile.vue"
export default component.exports